document.addEventListener("DOMContentLoaded", function () {
  // Helper: safely normalize body into string
  function normalizeBody(body) {
    if (typeof body === "string") return body;
    try {
      return JSON.stringify(body);
    } catch (e) {
      return "";
    }
  }

  // ✅ Patch global handleFetchRequest if it exists
  if (typeof window.handleFetchRequest === "function") {
    const oldHandler = window.handleFetchRequest;

    window.handleFetchRequest = async function (...args) {
      try {
        const result = await oldHandler.apply(this, args);

        // result may contain .body inside Booster’s wrapper
        if (result && result.body && typeof result.body !== "string") {
          result.body = normalizeBody(result.body);
        }

        return result;
      } catch (e) {
        console.warn("[ATC Hotfix] patched handleFetchRequest caught:", e);
        return oldHandler.apply(this, args);
      }
    };

    console.log("✅ Patched global handleFetchRequest");
  }

  // ✅ Patch Booster’s shop_events_listener object if it exists
  if (window.shop_events_listener &&
      typeof window.shop_events_listener.handleFetchRequest === "function") {

    const originalListener =
      window.shop_events_listener.handleFetchRequest;

    window.shop_events_listener.handleFetchRequest = async function (...args) {
      try {
        const res = await originalListener.apply(this, args);

        if (res && res.body && typeof res.body !== "string") {
          res.body = normalizeBody(res.body);
        }

        return res;
      } catch (err) {
        console.warn("[ATC Hotfix] shop_events_listener handled:", err);
        return originalListener.apply(this, args);
      }
    };

    console.log("✅ Patched shop_events_listener.handleFetchRequest");
  }
});
